import { format } from "date-fns";

/**
 * `15 September 2026`, the one date style the blog uses. Frontmatter dates are
 * mostly bare `YYYY-MM-DD`, which `new Date` reads as UTC midnight and so
 * renders a day early anywhere west of Greenwich; those are built as local
 * calendar dates instead.
 */
export function formatPostDate(iso: string): string {
  const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const date = day
    ? new Date(Number(day[1]), Number(day[2]) - 1, Number(day[3]))
    : new Date(iso);
  return format(date, "d MMMM yyyy");
}
